import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {Company} from "../../../interfaces/company.interface";
import {getAssistantPromptByTag} from "../../../utils/assistant-prompt.util";

@Component({
  selector: 'app-person-insights',
  templateUrl: './person-insights.component.html',
  styleUrls: ['./person-insights.component.scss']
})
export class PersonInsightsComponent {

  @Input() reportSearch: any;
  @Input() company: Company;
  @Input() edit: boolean | undefined;

  @Output() editPromptToggled = new EventEmitter<any>();
  @Output() editContactModalRequested = new EventEmitter<{ emails: string[]; phoneNumbers: string[]; contactType: string }>();

  isEnriched: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    // Check if reportSearch changed and update isEnriched
    if (changes['reportSearch'] && this.reportSearch) {
      this.isEnriched = this.reportSearch.is_enrich === 1;
    }
  }

  handleEdit(assistantPrompt: string, promptValue: string): void {

    this.editPromptToggled.emit({
      visible: true,              // Show the modal
      assistantPrompt: assistantPrompt,
      promptValue: promptValue
    });

  }

  onProfileEnriched(): void {
    // Update the local state immediately for better UX
    this.isEnriched = true;

    // Update the reportSearch object
    if (this.reportSearch) {
      this.reportSearch.is_enrich = 1;
    }
  }

}
